import React from 'react'
import Calculadora from './components/calculadora'

const App = () => {
  return (
    <div>
      <Calculadora />
    </div>
  )
}

export default App
